import React from 'react'

import QuestionMultipleChoice from 'lemon-campaign-ui/lib/organisms/QuestionMultipleChoice'

export default ({ component, handlers, defaults, recursive }) => {
  if (!component.components.length) {
    return null
  }
  return (
    <QuestionMultipleChoice
      {...defaults}
      draft={component.content.wysiwyg}
      align={component.content.align}
      color={component.content.color || ''}
      onSubmit={(answers) => handlers.multipleChoice(component, Object.keys(answers))}
    >
      {recursive(component.components)}
    </QuestionMultipleChoice>
  )
}
